import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deletePhrasesBulk } from '../api'
import { contentKeys } from '../queryKeys'

const useBulkDeletePhraseMutation = (selectedNodeId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deletePhrasesBulk,
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: contentKeys.phrases(selectedNodeId),
      })
    },
  })
}

export default useBulkDeletePhraseMutation
